import { campaignVerifyTokenAPI } from 'api/campaign'
import { Status } from 'api/common/statuses'
import Footer from 'components/Footer'
import HeaderLarge from 'components/HeaderLarge'
import Information from 'components/Information'
import * as React from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { buildCampaignDoneUrl } from 'constants/routes'

const ERROR_MESSAGES: Partial<Record<Status, string>> = {
  [Status.CampaignTokenInvalid]: 'リンクの有効期限が切れています。再度仮登録申込からやり直してください。',
  [Status.CampaignQrExpired]: 'リンクの有効期限が切れています。再度仮登録申込からやり直してください。',
  [Status.AlreadyRegistered]: 'このメールアドレスは既に登録されています。ログインして本登録にお進みください。',
}

const FALLBACK_ERROR_MESSAGE = '処理中にエラーが発生しました。時間をおいて再度お試しください。' as const

type ActionButton = Readonly<{ label: string; href: string }>

const LOGIN_ACTION: ActionButton = { label: 'ログイン画面へ', href: '/login' }
const RETRY_SIGNUP_ACTION: ActionButton = { label: '再度申込画面へ', href: '/signUpIntroduction' }

const STATUS_TO_ACTION_BUTTON: Partial<Record<Status, ActionButton>> = {
  [Status.AlreadyRegistered]: LOGIN_ACTION,
  [Status.CampaignTokenInvalid]: RETRY_SIGNUP_ACTION,
  [Status.CampaignQrExpired]: RETRY_SIGNUP_ACTION,
}

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const { token } = useParams()
  const [errorMessage, setErrorMessage] = React.useState<string>('')
  const [errorStatus, setErrorStatus] = React.useState<Status | null>(null)
  const [verifying, setVerifying] = React.useState<boolean>(true)
  const calledRef = React.useRef<boolean>(false)

  React.useEffect(() => {
    if (calledRef.current || !token) {
      return
    }
    calledRef.current = true
    campaignVerifyTokenAPI(token, (status) => {
      setVerifying(false)
      if (status === Status.Success) {
        navigate(buildCampaignDoneUrl(token))
        return
      }
      setErrorMessage(ERROR_MESSAGES[status] ?? FALLBACK_ERROR_MESSAGE)
      setErrorStatus(status)
    })
  }, [token, navigate])

  return (
    <>
      <HeaderLarge title="仮登録申込確認" />
      <main className="mx-4 my-5">
        {verifying && (
          <div className="d-flex flex-column align-items-center mt-5">
            <Spinner animation="border" />
            <p className="mt-3">確認処理中です…</p>
          </div>
        )}
        {!verifying && errorMessage && (
          <Information>
            <p>{errorMessage}</p>
            {errorStatus !== null && STATUS_TO_ACTION_BUTTON[errorStatus] && (
              <Button variant="outline-primary" className="w-100 py-3 mt-3" href={STATUS_TO_ACTION_BUTTON[errorStatus]!.href}>
                {STATUS_TO_ACTION_BUTTON[errorStatus]!.label}
              </Button>
            )}
          </Information>
        )}
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
